export default __webpack_public_path__ + "static/media/FactoryIconGray.06a9658a.svg";